import React, { useMemo } from 'react';
import Typography from 'antd/lib/typography';
import { DataQualityReportPeriod, DataQualityReportPeriodMap } from '../../domain/readings-availability-stats/interface';
import { SECONDARY_COLOR } from '../../theme';
import { getComputerFormattedTime } from '../../domain/date/date';

interface ITableTitleProps {
    period: DataQualityReportPeriod;
    updatedAt: string | null;
}

export const ReadingsAvailabilityStatsByCompanyTableTitle: React.FC<ITableTitleProps> = ({ period, updatedAt }) => {
    const periodTitle = DataQualityReportPeriodMap[period];
    const formattedDate = useMemo(() => {
        const date = updatedAt ? new Date(updatedAt) : new Date();
        return getComputerFormattedTime(date);
    }, [updatedAt]);

    return (
        <Typography.Title level={4} style={{ marginTop: 0, color: SECONDARY_COLOR, textAlign: 'center' }}>
            <span style={{ color: 'black' }}>{periodTitle}</span> Report of KW interval %
            <br />
            <Typography.Text style={{ marginTop: 0, color: SECONDARY_COLOR, textAlign: 'center' }}>
                Report last processed {formattedDate}
            </Typography.Text>
        </Typography.Title>
    );
};
